if ($('#category-header').length) {

  function setupFilterAccordion() {
    $(document).off('click.mhfilter', '.filter-section h4');

    $(document).on('click.mhfilter', '.filter-section h4', function () {
      var $section = $(this).closest('.filter-section');

      $('.filter-section')
        .not($section)
        .removeClass('openFilter')
        .removeAttr('style');

      $section.toggleClass('openFilter');

      if ($section.hasClass('openFilter')) {
        var formHeight =
          $section.find('form').outerHeight() ||
          ($section.find('.price-filter').outerHeight() +
           $section.find('.slider-content').outerHeight());

        $section.css('padding-bottom', formHeight + 'px');
      } else {
        $section.removeAttr('style');
      }
    });
  }

  // -------------------------------------

  function setupSelectedFilters() {
    if ($('.selected-filters').length) return;

    $('<div class="selected-filters"></div>').insertBefore('#productsListHeading');

    $('.filter-label.active').clone().appendTo('.selected-filters');
    $('.selected-filters .filter-label.active')
      .closest('div')
      .addClass('active-filter');

    $('#clear-filters').clone().appendTo('.selected-filters');
  }

  // -------------------------------------

  function setupManufacturerLetters() {
    var $inputs = $('#manufacturer-filter input[data-filter-id]');

    if (!$inputs.length) return;

    var letterSet = new Set();
    $inputs.each(function () {
      var id = $(this).data('filter-id');
      if (id) letterSet.add(id.charAt(0).toUpperCase());
    });

    var letters = Array.from(letterSet).sort();

    // Vytvoření abecedy – pouze jednou
    if (!$('.manufacturer-letters').length) {
      var $lettersDiv = $('<div class="manufacturer-letters"></div>');
      letters.forEach(letter => {
        $lettersDiv.append(`<span class="manufacturer-letter">${letter}</span>`);
      });
      $('#manufacturer-filter form').prepend($lettersDiv);
    }

    // Aktivní písmeno
    var activeLetters = [];
    $inputs.filter(':checked').each(function () {
      activeLetters.push($(this).data('filter-id').charAt(0).toUpperCase());
    });

    var currentLetter = activeLetters[0] || letters[0];

    // Zobrazení jen položek pod písmenem
    $('#manufacturer-filter form fieldset div').hide();
    $inputs.each(function () {
      var id = $(this).data('filter-id');
      if (id && id.charAt(0).toUpperCase() === currentLetter) {
        $(this).closest('div').show();
      }
    });

    // Nastavení tříd
    $('.manufacturer-letter')
      .removeClass('ActiveLetter clickedLetter')
      .filter(function () {
        return $(this).text() === currentLetter;
      })
      .addClass('ActiveLetter');

    letters.forEach(letter => {
      if (
        $inputs.filter(function () {
          return (
            $(this).data('filter-id').charAt(0).toUpperCase() === letter &&
            $(this).is(':checked')
          );
        }).length > 0
      ) {
        $('.manufacturer-letter')
          .filter(function () {
            return $(this).text() === letter;
          })
          .addClass('clickedLetter');
      }
    });
  }

  // -------------------------------------

  function bindManufacturerEvents() {
    // kliknutí na písmeno
    $(document).off('click.mhletters', '.manufacturer-letter');
    $(document).on('click.mhletters', '.manufacturer-letter', function () {
      var selected = $(this).text();

      $('.manufacturer-letter').removeClass('ActiveLetter');
      $(this).addClass('ActiveLetter');

      $('#manufacturer-filter form fieldset div').hide();

      $('#manufacturer-filter input[data-filter-id]').each(function () {
        var id = $(this).data('filter-id');
        if (id && id.charAt(0).toUpperCase() === selected) {
          $(this).closest('div').show();
        }
      });
       recalcOpenFilterHeight();
    });

    // změna checkboxu → vybarvení písmenka
    $(document).off('change.mhletters', '#manufacturer-filter input[data-filter-id]');
    $(document).on('change.mhletters', '#manufacturer-filter input[data-filter-id]', function () {
      var firstLetter = $(this).data('filter-id').charAt(0).toUpperCase();
      var $letter = $('.manufacturer-letter').filter(function () {
        return $(this).text() === firstLetter;
      });

      var anyChecked = $('#manufacturer-filter input[data-filter-id]').filter(function () {
        return $(this).data('filter-id').charAt(0).toUpperCase() === firstLetter && this.checked;
      }).length;

      $letter.toggleClass('clickedLetter', anyChecked > 0);
    });
     recalcOpenFilterHeight();
  }

  // -------------------------------------

  function setupPriceSlider() {
    if (!$('.slider-wrapper').length) return;

    if ($('.filterTitle').length === 0) {
      $('#filters').prepend('<h3 class="filterTitle">'+translation('filtrovaniProduktu')+'</h3>');
    }

    $('.slider-wrapper')
      .addClass('filter-section')
      .appendTo('.filter-sections #category-filter-hover')
      .append('<div class="price-filter"></div>');

    $('.slider-wrapper .slider-header').appendTo('.slider-wrapper .price-filter');
    $('.slider-wrapper .slider-content').appendTo('.slider-wrapper .price-filter');
  }

  // -------------------------------------

  function mhfilter() {
    setupPriceSlider();
    setupSelectedFilters();
    setupManufacturerLetters();
    setupFilterAccordion();
    bindManufacturerEvents();
  }

  $(document).ready(mhfilter);
  document.addEventListener('ShoptetDOMContentLoaded', mhfilter);
  document.addEventListener('ShoptetPageFilterValueChange', mhfilter);

  // jen doplnění click handlerů při načtení dalších produktů
  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', setupFilterAccordion);
}

function recalcOpenFilterHeight() {
  var $open = $('.filter-section.openFilter');

  if ($open.length) {
    var formHeight =
      $open.find('form').outerHeight() ||
      ($open.find('.price-filter').outerHeight() +
       $open.find('.slider-content').outerHeight());

    $open.css('padding-bottom', formHeight + 'px');
  }
}